import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import styled from 'styled-components';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useTranslation } from 'react-i18next';
import { PALETTE, BUTTON } from '~/assets/styles/base';

const StyledButton = styled(Button)`
  border-radius: ${BUTTON.roundedBorder.radius};
  &:hover {
    border: none;
  }
  &.MuiButton-root {
    width: 160px;
    font-size: 1.2rem;
    min-height: 32px;
    padding: 0;
    background-color: #fafbfc;
    border: 1px solid #a2b2be52;
    color: #333;
  }
  .MuiSvgIcon-root {
    margin-right: 5px;
  }
  .MuiButton-startIcon {
    margin-right: 0px;
    margin-top: 2px;
  }
  .MuiButton-startIcon > *:nth-of-type(1) {
    font-size: 14px;
    color: ${PALETTE.primary.main};
  }
`;

type Props = {
  handleClick: ButtonProps['onClick'];
  name: string;
};
/**
 * TODO: 後でui-elementsに移動する。
 */
const AddButton: React.FC<Props> = ({ handleClick, name }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledButton
      startIcon={<AddCircleIcon fontSize="small" data-testid={`uiParts-AddButton-icn-${name}`} />}
      data-testid={`uiParts-AddButton-btn-${name}`}
      onClick={handleClick}
      name={name}
    >
      {t('appCommon.add')}
    </StyledButton>
  );
};

export default AddButton;
